import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export function VantaCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const success = searchParams.get("success") === "true";
  const error = searchParams.get("error");
  const tenantId = searchParams.get("tenant_id");

  useEffect(() => {
    if (success && tenantId) {
      const timer = setTimeout(() => {
        navigate(`/tenants/${tenantId}/settings`, { replace: true });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [success, tenantId, navigate]);

  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <div className="text-center space-y-4 p-8">
        {success ? (
          <>
            <CheckCircle className="mx-auto h-12 w-12 text-success" />
            <h2 className="text-xl font-semibold text-text-primary">Vanta Connected!</h2>
            <p className="text-text-secondary">Redirecting to tenant settings...</p>
          </>
        ) : (
          <>
            <XCircle className="mx-auto h-12 w-12 text-danger" />
            <h2 className="text-xl font-semibold text-text-primary">Connection Failed</h2>
            <p className="text-sm text-text-secondary">
              {error === "invalid_state" && "The authorization link has expired. Please try again."}
              {error === "token_exchange_failed" && "Could not complete authorization with Vanta. Please try again."}
              {error === "tenant_not_found" && "Tenant not found. Please contact support."}
              {!error || (error !== "invalid_state" && error !== "token_exchange_failed" && error !== "tenant_not_found")
                ? "An error occurred during Vanta authorization."
                : null}
            </p>
            {tenantId && (
              <Button onClick={() => navigate(`/tenants/${tenantId}/settings`)}>
                Back to Settings
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
